import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { drawBonusCards } from './actions';
import { selectDrawingBonusCards } from './selectors';
import { selectGamePlayer } from '../ActiveGame/selectors';
import { Button, ButtonRow, Muted } from '../Controls';

/**
 * When the opponent's opening hand had no Basic Pokémon and was dealt again, the player may draw up to 2 extra
 * cards for each time (rulebook page 5). The server works out how many; the player picks once, before Ready.
 */
const BonusCards = ({ userId }) => {
  const dispatch = useDispatch();
  const gamePlayer = useSelector((state) => selectGamePlayer(state, { userId }));
  const drawing = useSelector(selectDrawingBonusCards);

  const allowed = gamePlayer ? gamePlayer.get('bonus_cards_allowed') || 0 : 0;

  if (!allowed || gamePlayer.get('bonus_cards_drawn') !== null || gamePlayer.get('ready')) {
    return null;
  }

  const counts = Array.from({ length: allowed }, (_, i) => allowed - i);

  return (
    <>
      <Muted>
        Your opponent's opening hand had no Basic Pokémon, so you may draw up to {allowed} extra cards.
      </Muted>
      <ButtonRow>
        {counts.map(count => (
          <Button key={count} $primary={count === allowed} onClick={() => dispatch(drawBonusCards(count))} disabled={drawing}>
            Draw {count}
          </Button>
        ))}
        <Button onClick={() => dispatch(drawBonusCards(0))} disabled={drawing}>No thanks</Button>
      </ButtonRow>
    </>
  );
};

BonusCards.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default BonusCards;
